export default "__VITE_ASSET__D_naYtxK__"